var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.271,
    height: 47.271,
    "data-name": "microsoft excel",
    viewBox: "0 0 47.271 47.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21a366",
    d: "M25.726,2H9.969A1.969,1.969,0,0,0,8,3.969V12.34l17.726,10.34,8.863,3.74,8.863-3.74V12.34Z",
    "data-name": "Path 62",
    transform: "translate(3.818 .954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M8,9H25.726V19.34H8Z",
    "data-name": "Path 63",
    transform: "translate(3.818 4.295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33c481",
    d: "M35.757,2H20V12.34H37.726V3.969A1.969,1.969,0,0,0,35.757,2Z",
    "data-name": "Path 64",
    transform: "translate(9.544 .954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#185c37",
    d: "M25.726,16H8V34.712a1.969,1.969,0,0,0,1.969,1.969H41.484a1.969,1.969,0,0,0,1.969-1.969V26.34Z",
    "data-name": "Path 65",
    transform: "translate(3.818 7.635)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M20,16H37.726V26.34H20Z",
    "data-name": "Path 66",
    transform: "translate(9.544 7.635)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,7H8V35.067H20.8A1.975,1.975,0,0,0,22.772,33.1V8.969A1.975,1.975,0,0,0,20.8,7Z",
    "data-name": "Path 67",
    opacity: 0.1,
    transform: "translate(3.818 3.34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.326,8H8V36.067H19.326A1.975,1.975,0,0,0,21.295,34.1V9.969A1.975,1.975,0,0,0,19.326,8Z",
    "data-name": "Path 68",
    opacity: 0.2,
    transform: "translate(3.818 3.818)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.326,8H8V33.112H19.326a1.975,1.975,0,0,0,1.969-1.969V9.969A1.975,1.975,0,0,0,19.326,8Z",
    "data-name": "Path 69",
    opacity: 0.2,
    transform: "translate(3.818 3.818)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.849,8H8V33.112h9.849a1.975,1.975,0,0,0,1.969-1.969V9.969A1.975,1.975,0,0,0,17.849,8Z",
    "data-name": "Path 70",
    opacity: 0.2,
    transform: "translate(3.818 3.818)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M1.969,8h19.7a1.969,1.969,0,0,1,1.969,1.969v19.7a1.969,1.969,0,0,1-1.969,1.969H1.969A1.969,1.969,0,0,1,0,29.666V9.969A1.969,1.969,0,0,1,1.969,8Z",
    "data-name": "Back Plate",
    transform: "translate(0 3.818)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.533,25.772l4.78-7.407L3.935,11H7.458l2.39,4.708q.329.669.454,1h.031q.236-.535.495-1.04L13.382,11h3.234l-4.491,7.324,4.6,7.448H13.287L10.526,20.6a4.316,4.316,0,0,1-.329-.691h-.041a3.26,3.26,0,0,1-.319.669L7,25.772Z",
    "data-name": "Path 71",
    transform: "translate(1.686 5.249)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H47.271V47.271H0Z",
    "data-name": "Path 72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcel);
export default __webpack_public_path__ + "static/media/microsoft-excel.3d5466cdae09412c96b00bdfb46b5dac.svg";
export { ForwardRef as ReactComponent };